export type ProgressOffer={status:string;requirement_id?:string;terms?:{requirement_id?:string};booking?:{status:string;hires:{status:string}[]}|null};
export function bookingProgress(offer:ProgressOffer):string{
 if(offer.status!=='accepted')return offer.status==='sent'?'quoted':offer.status;
 const booking=offer.booking;
 if(!booking)return 'accepted';
 if(booking.status!=='confirmed')return booking.status;
 const states=booking.hires.map(h=>h.status);
 if(states.length&&states.every(s=>s==='collected'))return 'collected';
 if(states.includes('active'))return states.includes('confirmed')?'partially_active':'active';
 if(states.includes('offhire_requested'))return 'offhire_requested';
 return 'confirmed';
}
